import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { UmbracoLink } from '@models/umbraco.model';
import { SettingsService } from '@core/services/settings.service';
import { map, withLatestFrom } from 'rxjs/operators';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { PageReferencesViewModel } from '@models/api.models';

type PageReference = keyof PageReferencesViewModel;

@Pipe({
    name: 'isClubMemberPage',
    standalone: true
})
export class IsClubMemberPagePipe implements PipeTransform {
    private settingsService: SettingsService = inject(SettingsService);
    private authService: AuthenticationService = inject(AuthenticationService);

    transform(value: UmbracoLink, reference: PageReference): Observable<boolean> {
        return this.authService.loginState$.pipe(
            withLatestFrom(this.settingsService.settings$),
            map(([{ loggedIn }, { pageReferences }]) => {
                if (!pageReferences) return false;
                const pageReference = pageReferences[reference] as UmbracoLink;
                return loggedIn && pageReference?.url === value.url;
            })
        );
    }
}
